import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import { formatISO } from "date-fns";

const MetaBaseDashBoardFive = () => {
  const [iframeUrl50, setIframeUrl50] = useState("");
  const [iframeUrl53, setIframeUrl53] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [iframeUrlApi] = useIframeUrlMutation();

  const getMonthDateRange = (date = new Date()) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return { firstDay, lastDay };
  };

  useEffect(() => {
    const { firstDay, lastDay } = getMonthDateRange();
    setStartDate(firstDay);
    setEndDate(lastDay);
  }, []);

  const fetchIframeUrls = async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError("");

    const payload = {
      StartDate: `${formatISO(startDate, { representation: "date" })} 00:00:00`,
      EndDate: `${formatISO(endDate, { representation: "date" })} 23:59:59`,
    };

    try {
      const [res50, res53] = await Promise.all([
        iframeUrlApi({
          questionId: 50,
          params: payload,
          expMinutes: 10,
          bordered: true,
          titled: true,
        }).unwrap(),
        iframeUrlApi({
          questionId: 53,
          params: payload,
          expMinutes: 10,
          bordered: true,
          titled: true,
        }).unwrap(),
      ]);

      setIframeUrl50(res50.iframeUrl);
      setIframeUrl53(res53.iframeUrl);
    } catch (err) {
      console.error(err);
      setError("Failed to load dashboards");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIframeUrls();
  }, [startDate, endDate]);

  const resetForm = () => {
    const { firstDay, lastDay } = getMonthDateRange();
    setStartDate(firstDay);
    setEndDate(lastDay);
  };

  return (
    <div style={{ position: "relative", padding: "20px" }}>
      <div className="iframe-card">
        <div>
          <label style={{ display: "block", marginBottom: "4px" }}>Start Date</label>
          <input
            type="date"
            value={startDate ? formatISO(startDate, { representation: "date" }) : ""}
            onChange={(e) =>
              setStartDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>

        <div>
          <label  style={{ display: "block", marginBottom: "4px" }}>End Date</label>
          <input
            type="date"
            value={endDate ? formatISO(endDate, { representation: "date" }) : ""}
            onChange={(e) =>
              setEndDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      </div>

      {loading && <p>Loading dashboards...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* FIRST IFRAME */}
      <div className="pie-chart-card">
        {iframeUrl50 ? (
          <iframe
            src={iframeUrl50}
            width="100%"
            height="500"
            frameBorder="0"
            style={{ borderRadius: "8px" }}
            title="Dashboard 50"
          />
        ) : (
          <p>Select date range to load dashboard 50</p>
        )}
      </div>

      {/* SECOND IFRAME */}
      <div className="pie-chart-card" style={{ marginTop: "30px" }}>
        {iframeUrl53 ? (
          <iframe
            src={iframeUrl53}
            width="100%"
            height="500"
            frameBorder="0"
            style={{ borderRadius: "8px" }}
            title="Dashboard 53"
          />
        ) : (
          <p>Select date range to load dashboard 53</p>
        )}
      </div>
    </div>
  );
};

export default MetaBaseDashBoardFive;
